import classNames from 'classnames';
import { BEMBlock } from 'helpers/classnames';
import { Small, BodyText } from 'palette/Typography';
import { Size } from './constants';
import type { BadgeType } from './types';
import './styles/Badge.scss';

const sizeToTypographyMap: Record<Size, typeof Small | typeof BodyText> = {
    xs: Small,
    s: Small,
    m: BodyText,
};

function Badge({
    size = 's',
    theme = 'dark',
    label,
    className,
}: BadgeType) {
    const [block, BEMElement] = BEMBlock('palette-badge', {
        [`size-${size}`]: size !== undefined,
        [`theme-${theme}`]: theme !== undefined,
    });
    const blockClasses = classNames(block, className);
    const BadgeComponent = sizeToTypographyMap[size];

    return (
        <div className={blockClasses}>
            {label !== undefined ? (
                <BadgeComponent
                    className={BEMElement('label')}
                    color="inherit"
                    level="2"
                >
                    {label}
                </BadgeComponent>
            ) : null}
        </div>
    );
}

export default Badge;
